import { Controller } from "@hotwired/stimulus";
import { trackProofEvent } from "../proof_events.js";

// One video_play and one video_complete per page view, however often the
// visitor pauses, resumes or replays: the rates divide by page views.
//
// The poster draws its own play button, so the native controls are hidden
// until the first play: they would cover the logo and the caption at the
// bottom of the poster. The markup ships with controls on and the start button
// hidden, so the video still plays without JavaScript.
export default class extends Controller {
  static targets = ["video", "start"];
  static values = { offer: { type: String, default: "other" } };

  connect() {
    if (!this.hasVideoTarget || !this.hasStartTarget || !this.videoTarget.paused) return;

    this.videoTarget.controls = false;
    this.startTarget.hidden = false;
  }

  start() {
    this.reveal();
    this.videoTarget.play();
  }

  play() {
    this.reveal();
    if (this.played) return;
    this.played = true;
    trackProofEvent("video_play", this.offerValue);
  }

  ended() {
    if (this.completed) return;
    this.completed = true;
    trackProofEvent("video_complete", this.offerValue);
  }

  reveal() {
    if (this.hasVideoTarget) this.videoTarget.controls = true;
    if (this.hasStartTarget) this.startTarget.hidden = true;
  }
}
